import React, { useEffect, useState } from 'react';

const RenderChildren = ({ children }: { children: React.ReactNode }) =>
  children;

export const InteractiveWrapper = ({
  wait,
  sideEffect,
  wrapper,
  children,
}: {
  wait?: number;
  sideEffect?: () => void;
  wrapper?: React.ComponentType;
  children: React.ReactNode;
}) => {
  const [testReady, setTestReady] = useState(false);
  useEffect(() => {
    if (wait) {
      setTimeout(() => setTestReady(true), wait);
    } else {
      setTestReady(true);
    }
  }, [wait]);

  useEffect(() => {
    if (sideEffect) {
      sideEffect();
    }
  }, [sideEffect]);

  const Wrapper = wrapper || RenderChildren;

  return (
    <div data-test-ready={testReady}>
      <Wrapper>{children}</Wrapper>
    </div>
  );
};
